export const projects = [
  {
    id: "dark-factory",
    title: "Personal Software Dark Factory",
    description:
      "Automation tooling that centralizes deployments, background jobs, and developer workflows to reduce manual operations.",
    technologies: [
      "Applied AI",
      "Agentic Workflows",
      "OpenRouter",
      "Docker",
      "Python",
    ],
    weight: 0.9,
  },
  {
    id: "discord-bot",
    title: "Sports Discord Bot",
    description:
      "A bot that automates scheduling and signups for local teams, reducing coordination overhead and missed communications.",
    technologies: ["Node.js", "Docker", "Python", "MongoDB"],
    weight: 0.8,
  },
  {
    id: "stock-analysis-website",
    title: "Stock Analysis Website",
    description:
      "An interactive dashboard that surfaces market indicators and visual snapshots to support exploratory research.",
    technologies: ["React", "Node.js", "Vite"],
    weight: 0.9,
  },
  {
    id: "ata-project",
    title: "ATA Hackathon Project",
    description:
      "A two-sided operations tool to track equipment status and coordinate passenger communications for airline crews.",
    technologies: ["React", "C#"],
    weight: 0.7,
  },
  {
    id: "website-support-server",
    title: "Website Support Server",
    description:
      "A Node.js service offering reusable operational endpoints for site health, logs, and basic automation.",
    technologies: ["Node.js", "Docker"],
    weight: 0.7,
  },
  {
    id: "website-creation-with-ai",
    title: "Website Creation With AI",
    description:
      "A rapid prototyping workflow that uses templates and AI-assisted tooling to produce initial client sites quickly.",
    technologies: ["React", "Applied AI", "Tailwind", "Node.js"],
    weight: 0.9,
  },
  {
    id: "example-business-website",
    title: "Custom Business Website",
    description:
      "A tailored marketing site built to match client requirements with clear content structure and simple operations.",
    technologies: ["React", "Tailwind", "Vite"],
    weight: 0.9,
  },
  {
    id: "portfolio-website",
    title: "Portfolio Website",
    description:
      "The portfolio site that presents software work, leadership experience, and selected projects.",
    technologies: ["React", "Vite", "Node.js"],
    weight: 0.9,
  },
];
